import { HttpInterceptorFn } from '@angular/common/http';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const cloned = req
    .clone
    //   {
    //   setHeaders: {
    //     Authorization: 'Bearer token',
    //   },
    // }
    ();

  return next(cloned);
};
